// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const uppercase: MarkdocFunctionSchema = {
  render(parameters): string {
    const string = parameters['0'];

    return typeof string === 'string' ? string.toUpperCase() : string;
  },
};
